import axios from 'axios';

const shopApi = axios.create({
  baseURL: 'https://ecommerce.pw1.develop.us-east-1.qesh.ai/v1/',

});

export default shopApi;
